import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaTimesCircle, FaArrowLeft, FaQuestionCircle } from 'react-icons/fa';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl shadow-xl p-8 max-w-md mx-auto text-center"
      >
        {/* Cancel Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="mb-6"
        >
          <FaTimesCircle className="text-6xl text-orange-500 mx-auto" />
        </motion.div>

        {/* Cancel Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Payment Cancelled
          </h1>
          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
        </motion.div>

        {/* Information Box */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6"
        >
          <div className="flex items-start">
            <FaQuestionCircle className="text-orange-500 mt-1 mr-3 flex-shrink-0" />
            <div className="text-left">
              <h3 className="font-medium text-orange-800 mb-2">Need Help?</h3>
              <p className="text-orange-700 text-sm">
                If you experienced any issues during checkout or have questions about our premium features, 
                please don't hesitate to contact our support team.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="space-y-4"
        >
          <button
            onClick={() => navigate('/lessons')}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-lg transition-all transform hover:scale-105"
          >
            Try Payment Again
          </button>
          
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-lg transition-colors flex items-center justify-center"
          >
            <FaArrowLeft className="mr-2" />
            Continue Browsing
          </button>
        </motion.div>

        {/* Support Contact */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="mt-6 text-sm text-gray-600"
        >
          Need assistance? Contact us at{' '}
          <a href="mailto:support@yourplatform.com" className="text-orange-500 hover:text-orange-600">
            support@yourplatform.com
          </a>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;